<template>
  <div class="layout-full-page">
    <div class="container">
        <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'layout-full-page'
}
</script>

<style>
.layout-full-page {
    height: 100vh;
    display: flex;
    align-items: center;
}
</style>
